import { customerApi } from "../api";

const CustomerService = {
    /**
     * Obtiene todos los clientes con paginación.
     * GET /api/customers/list?page=0&size=10
     */
    getAllPaged: async (page: number, size: number) => {
        try {
            const response = await customerApi.fetchCustom(`/list?page=${page}&size=${size}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtiene una lista paginada de clientes filtrados.
     * POST /api/customers/filtered?page=X&size=Y&sort=campo,asc|desc
     */
    getFiltered: async (
        filter: any,       // puedes crear un tipo CustomerFilter si quieres tiparlo mejor
        page = 0,
        size = 10,
        sort = 'name,asc' // 🔥 por defecto orden alfabético, cámbialo si deseas
    ) => {
        try {
            const response = await customerApi.addCustom(
                `/filtered?page=${page}&size=${size}&sort=${sort}`,
                filter
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    /**
     * Obtiene clientes en formato dropdown.
     * GET /api/customers/dropdown
     */
    getDropdown: async () => {
        try {
            const response = await customerApi.fetchCustom("/dropdown");
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtiene un cliente por ID.
     * GET /api/customers/{id}
     */
    getById: async (id: number) => {
        try {
            const response = await customerApi.fetchCustom(`/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtiene un cliente por ID para Editar.
     * GET /api/edit/{id}
     */
    getCustomerForEdit: async (id: number) => {
        try {
            const response = await customerApi.fetchCustom(`/edit/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crea un nuevo cliente.
     * POST /api/customers
     */
    add: async (data: Object) => {
        try {
            const response = await customerApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualiza un cliente por ID.
     * PUT /api/customers/{id}
     */
    modify: async (id: number, data: Object) => {
        try {
            const response = await customerApi.modify(id, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Cambia el estado de un cliente (activo/inactivo).
     * PATCH /api/customers/{id}/toggle-status
     */
    toggleStatus: async (id: number) => {
        try {
            const response = await customerApi.patchCustom(`${id}/toggle-status`);
            return response;
        } catch (error) {
            throw error;
        }
    },
};

export default CustomerService;
